import { useMemo, forwardRef, Suspense, cloneElement } from 'react';
import { useInView } from 'react-intersection-observer'
import EmptyPlaceholder from '../empty-placeholder';

const DefaultPlaceholder = forwardRef((props, ref) => {
	return (
		<EmptyPlaceholder styles={{height: '10rem'}} ref={ref} />
	)
});

const LazyComponent = ({ component, children, margin = '50px', placeholder = null, ...props }) => {
	const [ref, inView] = useInView({
		threshold: 0,
		rootMargin: margin,
		triggerOnce: true,
	});

	const Placeholder = useMemo(() => {
		return placeholder ? cloneElement(placeholder, { ref: ref }) : <DefaultPlaceholder ref={ref} />;
	}, [placeholder, ref])

	if(inView) {
		return (
			<Suspense fallback={Placeholder}>
				{children}
			</Suspense>
		)
	}
	else {
		return Placeholder;
	}
}

export default LazyComponent;